const navbarBurger= {};

navbarBurger.init = () => {

    const $navbar = document.querySelector(".js-navbar");
    const $navbarBurger = document.querySelectorAll(".js-navbar-burger");

    if ($navbarBurger) {
        for (let i=0; i<$navbarBurger.length; i++) {
            $navbarBurger[i].addEventListener("click", toggleMenu, false);
        }
    }

    function toggleMenu(e) {
        let dataTarget = e.target.getAttribute('data-target');
        let $navbarTarget = document.getElementById(dataTarget);
        let $selectedMenu = document.querySelectorAll(".is-menu-selected");
        const $navbarBurgerActive = document.querySelectorAll(".js-navbar-burger.is-active");

        // remove selected class from every menu
        for (let i=0; i<$selectedMenu.length; i++) {
            $selectedMenu[i].classList.remove("is-menu-selected");
        }

        // remove active class from every navbar button
        for (let i=0; i<$navbarBurgerActive.length; i++) {
            $navbarBurgerActive[i].classList.remove("is-active");
        }

        if ($navbar.classList.contains("is-active")) {
            e.target.setAttribute('aria-expanded', false);
            $navbar.classList.remove("is-active");
            document.documentElement.classList.remove('no-overflow');
        } else {
            e.target.setAttribute('aria-expanded', true);
            $navbarTarget.classList.add("is-menu-selected");
            $navbar.classList.add("is-active");
            e.target.classList.add("is-active");
            document.documentElement.classList.add('no-overflow');
        }
    }

}

export default navbarBurger;
